exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2xzOzpHd1PSFTqhxBw82UD .reLhLJ1a_p_L_1-soR2oK{display:flex;justify-content:space-around;padding-bottom:30px;margin-left:30px;margin-right:30px}._2xzOzpHd1PSFTqhxBw82UD .reLhLJ1a_p_L_1-soR2oK ._2gdEM6bcHD_lzfWXVKmIqs{flex:0 0 auto;font-size:40px;color:#fff}._2xzOzpHd1PSFTqhxBw82UD .reLhLJ1a_p_L_1-soR2oK ._2gdEM6bcHD_lzfWXVKmIqs:visited,._2xzOzpHd1PSFTqhxBw82UD .reLhLJ1a_p_L_1-soR2oK ._2gdEM6bcHD_lzfWXVKmIqs:active,._2xzOzpHd1PSFTqhxBw82UD .reLhLJ1a_p_L_1-soR2oK ._2gdEM6bcHD_lzfWXVKmIqs:hover{text-decoration:none}._2xzOzpHd1PSFTqhxBw82UD ._3eED-EvOMWTC3vtNAuHWOM{margin-top:-2px;margin-right:5px}\n", ""]);

// Exports
exports.locals = {
	"ShareModal": "_2xzOzpHd1PSFTqhxBw82UD",
	"shareIcons": "reLhLJ1a_p_L_1-soR2oK",
	"icon": "_2gdEM6bcHD_lzfWXVKmIqs",
	"ctaIcon": "_3eED-EvOMWTC3vtNAuHWOM"
};